<template>
    <form :id="id" @submit.prevent="handleSubmit">
        <fieldset :disabled="disabled">
            <x-form-group label="ID" v-if="fields.id" :horizontal="false">
                <input
                    type="text"
                    class="form-control"
                    :value="`#${fields.id}`"
                    disabled
                />
            </x-form-group>

            <x-form-group label="Status" :horizontal="false">
                <select class="form-control" v-model="fields.status">
                    <option value="pending">Pending</option>
                    <option value="billed">Billed</option>
                    <option value="paid">Paid</option>
                </select>
            </x-form-group>
        </fieldset>
    </form>
</template>

<script>
import XFormGroup from "../../components/XFormGroup.vue";
import FormDataMixin from "../../mixins/FormDataMixin";
import FormErrorMixin from "../../mixins/FormErrorMixin";
import PropertySyncMixin from "../../mixins/PropertySyncMixin";

export default {
    components: {
        XFormGroup,
    },
    created() {
        this.fields = {
            ...this.fields,
            ...this.initialFields,
        };
    },
    data() {
        return {
            fields: {
                id: null,
                status: null,
            },
            isLoading: false,
        };
    },
    methods: {
        handleSubmit() {
            const formData = this.buildFormData({
                ...this.fields,
            });
            this.$emit("submit", formData);
        },
    },
    mixins: [FormDataMixin, FormErrorMixin, PropertySyncMixin],
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        errors: {
            type: Object,
            required: false,
            default: null,
        },
        id: {
            type: String,
            required: false,
            default: null,
        },
        initialFields: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        readonly: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
};
</script>
